import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import oasis from "../../images/film/oasis.jpg";
import bird from "../../images/film/bird.jpg";
import acompleteunknown from "../../images/film/acompleteunknown.jpg";

function Film() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            FILM SCREENINGS
          </Typography>
          <Typography className="title venue-title" variant="h6">
            UPSTAIRS @ LASS O'GOWRIE
          </Typography>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                A COMPLETE UNKNOWN <span>14:30</span>
              </Typography>
              <Typography className="text">
                In 1961, an unknown 19-year-old Bob Dylan arrives in NYC with
                his guitar and forges relationships with musical icons on his
                meteoric rise, culminating in a groundbreaking performance that
                reverberates around the world.
              </Typography>
            </div>

            <img
              src={acompleteunknown}
              className="acompleteunknown-film"
              alt="acompleteunknown film"
            />
          </div>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                BIRD <span>16:45</span>
              </Typography>
              <Typography className="text">
                Bailey lives with her brother Hunter and her father Bug, who
                raises them alone in a squat in northern Kent. Bug doesn't have
                much time to devote to them. Bailey looks for attention and
                adventure elsewhere.
              </Typography>
            </div>
            <img src={bird} className="bird-film" alt="bird film" />
          </div>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                SUPERSONIC <span>19:15</span>
              </Typography>
              <Typography className="text">
                Oasis's breakthrough years documented into a detailed depiction of the band from the formation in Manchester in the early 1990s leading up to the legendary performance at Knebworth Festival.
              </Typography>
            </div>
            <img src={oasis} className="oasis-film" alt="oasis film" />
          </div>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@manchesterpsychfest.com</Typography>
        </div>
      </div>
    </Container>
  );
}
export default Film;
